"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[505],{

/***/ 1584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Training; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Alert/Alert.tsx + 1 modules
var Alert = __webpack_require__(60585);
// EXTERNAL MODULE: ./src/components/CartSupport/Support.tsx + 1 modules
var Support = __webpack_require__(28624);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/react-tooltip.min.mjs + 4 modules
var react_tooltip_min = __webpack_require__(20684);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/GlobalTooltip/GlobalTooltipTemplate.tsx




var GlobalTooltipTemplate = function GlobalTooltipTemplate() {
  var tooltip = /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_tooltip_min/* Tooltip */.u, {
      className: "tooltip",
      id: "favourite-tooltip"
    })
  });

  if (false) {}

  var container = document.getElementById('tooltips-container');
  return container ? /*#__PURE__*/react_dom.createPortal(tooltip, container) : null;
};
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Modal/Modal.tsx + 9 modules
var Modal = __webpack_require__(81579);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/material.utils.ts
var material_utils = __webpack_require__(27098);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/TrainingBenefit/TrainingBenefit.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingBenefitelements__Wrapper",
  componentId: "sc-14hzhtj-0"
})(["margin:", " 0;@media (min-width:", "px){padding:", " ", ";border:1px solid ", ";border-radius:", ";}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(25), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryGrey;
}, (0,polished_esm/* rem */.hO)(16));
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingBenefitelements__Section",
  componentId: "sc-14hzhtj-1"
})(["&:not(:last-child){border-bottom:1px solid ", ";}padding:", " 0;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondaryGrey;
}, (0,polished_esm/* rem */.hO)(20));
var Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingBenefitelements__Title",
  componentId: "sc-14hzhtj-2"
})(["font-weight:", ";font-size:", ";display:block;padding-bottom:", ";margin-bottom:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10));
var HarmonogramPartTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingBenefitelements__HarmonogramPartTitle",
  componentId: "sc-14hzhtj-3"
})(["padding:", " 0;display:block;"], (0,polished_esm/* rem */.hO)(10));
var HarmonogramDay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingBenefitelements__HarmonogramDay",
  componentId: "sc-14hzhtj-4"
})(["display:flex;flex-direction:column;margin:", " 0 0 0;"], (0,polished_esm/* rem */.hO)(15));
var HarmonogramDayDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingBenefitelements__HarmonogramDayDescription",
  componentId: "sc-14hzhtj-5"
})(["p{margin:", " 0;}"], (0,polished_esm/* rem */.hO)(4));
var HarmonogramDayTime = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingBenefitelements__HarmonogramDayTime",
  componentId: "sc-14hzhtj-6"
})(["font-weight:", ";min-width:", ";display:inline-block;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(150));
var Benefits = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingBenefitelements__Benefits",
  componentId: "sc-14hzhtj-7"
})(["a{color:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primary;
});
var Benefit = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingBenefitelements__Benefit",
  componentId: "sc-14hzhtj-8"
})(["padding-top:", ";display:flex;"], (0,polished_esm/* rem */.hO)(10));
var BenefitIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "TrainingBenefitelements__BenefitIcon",
  componentId: "sc-14hzhtj-9"
})(["svg{width:", ";height:", ";path{fill:", ";}}margin-right:", ";margin-top:", ";"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(15), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.green;
}, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(5));
var BenefitLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingBenefitelements__BenefitLabel",
  componentId: "sc-14hzhtj-10"
})([""]);
var Materials = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingBenefitelements__Materials",
  componentId: "sc-14hzhtj-11"
})([""]);
var Material = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingBenefitelements__Material",
  componentId: "sc-14hzhtj-12"
})(["padding-top:", ";display:flex;cursor:pointer;"], (0,polished_esm/* rem */.hO)(10));
var MaterialIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "TrainingBenefitelements__MaterialIcon",
  componentId: "sc-14hzhtj-13"
})(["svg{width:", ";height:", ";}margin-right:", ";"], (0,polished_esm/* rem */.hO)(19), (0,polished_esm/* rem */.hO)(19), (0,polished_esm/* rem */.hO)(10));
var MaterialLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingBenefitelements__MaterialLabel",
  componentId: "sc-14hzhtj-14"
})(["color:", ";font-weight:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.primary;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeights.textBold;
});
;// CONCATENATED MODULE: ./src/components/TrainingBenefit/TrainingBenefit.tsx








var ONLINE_BONUSES_PREFIX = 'o:';
var PRESENCE_BONUSES_PREFIX = 'p:';

var TrainingBenefitTemplate = function TrainingBenefitTemplate(_ref) {
  var _bonuses$split, _bonuses$split2, _bonuses$split3, _benefits$split, _benefits$split2, _instructionAttachmen;

  var benefits = _ref.benefits,
      bonuses = _ref.bonuses,
      defaultHarmonogram = _ref.harmonogram,
      instructions = _ref.instructions,
      instructionAttachments = _ref.instructionAttachments;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)([]),
      harmonogram = _useState[0],
      setHarmonogram = _useState[1];

  (0,react.useEffect)(function () {
    if (defaultHarmonogram) {
      setHarmonogram(defaultHarmonogram);
    }
  }, []);
  var globalBonuses = bonuses === null || bonuses === void 0 ? void 0 : (_bonuses$split = bonuses.split('|')) === null || _bonuses$split === void 0 ? void 0 : _bonuses$split.filter(function (bonus) {
    return !(bonus !== null && bonus !== void 0 && bonus.includes(ONLINE_BONUSES_PREFIX)) && !(bonus !== null && bonus !== void 0 && bonus.includes(PRESENCE_BONUSES_PREFIX));
  });
  var onlineBonuses = bonuses === null || bonuses === void 0 ? void 0 : (_bonuses$split2 = bonuses.split('|')) === null || _bonuses$split2 === void 0 ? void 0 : _bonuses$split2.filter(function (bonus) {
    return bonus === null || bonus === void 0 ? void 0 : bonus.includes(ONLINE_BONUSES_PREFIX);
  });
  var presenceBonuses = bonuses === null || bonuses === void 0 ? void 0 : (_bonuses$split3 = bonuses.split('|')) === null || _bonuses$split3 === void 0 ? void 0 : _bonuses$split3.filter(function (bonus) {
    return bonus === null || bonus === void 0 ? void 0 : bonus.includes(PRESENCE_BONUSES_PREFIX);
  });
  console.log('AA', instructionAttachments);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [!!benefits && (benefits === null || benefits === void 0 ? void 0 : (_benefits$split = benefits.split('|')) === null || _benefits$split === void 0 ? void 0 : _benefits$split.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
        children: [t('training.benefits'), ":"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Benefits, {
        children: benefits === null || benefits === void 0 ? void 0 : (_benefits$split2 = benefits.split('|')) === null || _benefits$split2 === void 0 ? void 0 : _benefits$split2.map(function (benefit, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitIcon, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
              children: benefit
            })]
          }, index);
        })
      })]
    }), !!bonuses && !!globalBonuses && (globalBonuses === null || globalBonuses === void 0 ? void 0 : globalBonuses.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
        children: [t('training.bonuses'), ":"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Benefits, {
        children: globalBonuses === null || globalBonuses === void 0 ? void 0 : globalBonuses.map(function (bonus, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitIcon, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
              children: bonus
            })]
          }, index);
        })
      })]
    }), !!bonuses && !!onlineBonuses && (onlineBonuses === null || onlineBonuses === void 0 ? void 0 : onlineBonuses.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
        children: [t('training.bonuses.online'), ":"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Benefits, {
        children: onlineBonuses === null || onlineBonuses === void 0 ? void 0 : onlineBonuses.map(function (bonus, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitIcon, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
              children: bonus === null || bonus === void 0 ? void 0 : bonus.replace(ONLINE_BONUSES_PREFIX, '')
            })]
          }, index);
        })
      })]
    }), !!bonuses && !!presenceBonuses && (presenceBonuses === null || presenceBonuses === void 0 ? void 0 : presenceBonuses.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
        children: [t('training.bonuses.presence'), ":"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Benefits, {
        children: presenceBonuses === null || presenceBonuses === void 0 ? void 0 : presenceBonuses.map(function (bonus, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitIcon, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
              children: bonus === null || bonus === void 0 ? void 0 : bonus.replace(PRESENCE_BONUSES_PREFIX, '')
            })]
          }, index);
        })
      })]
    }), (harmonogram === null || harmonogram === void 0 ? void 0 : harmonogram.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
        children: [t('training.program'), ":"]
      }), harmonogram === null || harmonogram === void 0 ? void 0 : harmonogram.map(function (day, dayIndex) {
        var _day$part;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [(harmonogram === null || harmonogram === void 0 ? void 0 : harmonogram.length) > 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(HarmonogramPartTitle, {
            children: day.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: (_day$part = day.part) === null || _day$part === void 0 ? void 0 : _day$part.map(function (part, partIndex) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(HarmonogramDay, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HarmonogramDayTime, {
                  children: [moment_default()(part.from).local().format('HH:mm'), " -", ' ', moment_default()(part.to).local().format('HH:mm')]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(HarmonogramDayDescription, {
                  dangerouslySetInnerHTML: {
                    __html: part.description
                  }
                })]
              }, partIndex);
            })
          })]
        }, dayIndex);
      })]
    }), (instructions || (instructionAttachments === null || instructionAttachments === void 0 ? void 0 : instructionAttachments.length) > 0) && /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
        children: [t('training.instructions'), ":"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Benefits, {
        dangerouslySetInnerHTML: {
          __html: instructions
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Materials, {
        children: instructionAttachments === null || instructionAttachments === void 0 ? void 0 : (_instructionAttachmen = instructionAttachments.filter(function (attachment) {
          return attachment;
        })) === null || _instructionAttachmen === void 0 ? void 0 : _instructionAttachmen.map(function (attachment, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Material, {
            onClick: function onClick() {
              return (0,material_utils/* handleDownloadClick */.b)(attachment._key, attachment.filename);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MaterialIcon, {
              name: Icon/* Icons.File */.PJ.File
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(MaterialLabel, {
              children: attachment === null || attachment === void 0 ? void 0 : attachment.name
            })]
          }, key);
        })
      })]
    })]
  });
};

/* harmony default export */ var TrainingBenefit = (TrainingBenefitTemplate);
// EXTERNAL MODULE: ./src/components/TrainingDates/TrainingDates.tsx + 1 modules
var TrainingDates = __webpack_require__(84634);
// EXTERNAL MODULE: ./src/ui/Lecturer/Lecturer.tsx + 1 modules
var Lecturer = __webpack_require__(58596);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
;// CONCATENATED MODULE: ./src/components/TrainingDescription/TrainingDescription.elements.tsx



var TrainingDescription_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingDescriptionelements__Wrapper",
  componentId: "sc-1f86r0m-0"
})(["position:relative;margin:", " 0 0 0;padding:", " 0;color:", ";@media (min-width:", "px){padding:0;margin:", " 0;}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(15), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grey;
}, theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(40));
var Lecturers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingDescriptionelements__Lecturers",
  componentId: "sc-1f86r0m-1"
})(["@media (min-width:", "px){width:75%;}"], theme/* breakpoints.sm */.A.sm);
var DescriptionMoreLink = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "TrainingDescriptionelements__DescriptionMoreLink",
  componentId: "sc-1f86r0m-2"
})(["background:none;padding:0;border:none;cursor:pointer;text-decoration:underline;color:", ";font-size:", ";margin-top:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(20));
var Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingDescriptionelements__Description",
  componentId: "sc-1f86r0m-3"
})(["padding-top:", ";line-height:", ";font-size:", ";&.short{line-clamp:5;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:5;overflow:hidden;}&.long{line-clamp:unset;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(28), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h6;
});
;// CONCATENATED MODULE: ./src/components/TrainingDescription/TrainingDescription.tsx








var LINE_HEIGHT = 28;
var SPACE = 56;

var TrainingDescriptionTemplate = function TrainingDescriptionTemplate(_ref) {
  var lecturers = _ref.lecturers,
      description = _ref.description,
      courseKey = _ref.courseKey,
      isFavoriteDefault = _ref.isFavorite;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)(true),
      isVisibleFullDescription = _useState[0],
      setIsVisibleFullDescription = _useState[1];

  var _useState2 = (0,react.useState)(false),
      hideLink = _useState2[0],
      setHideLink = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isLoaded = _useState3[0],
      setIsLoaded = _useState3[1];

  (0,react.useEffect)(function () {
    if ((document.getElementById('description').offsetHeight - SPACE) / LINE_HEIGHT <= 5) {
      setHideLink(true);
      setIsLoaded(true);
    } else {
      setIsVisibleFullDescription(false);
      setIsLoaded(true);
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TrainingDescription_elements_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Lecturers, {
      children: lecturers === null || lecturers === void 0 ? void 0 : lecturers.map(function (lecturer, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Lecturer/* default */.Z, {
          isBold: true,
          image: lecturer !== null && lecturer !== void 0 && lecturer.photoKey ? "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/people/").concat(lecturer === null || lecturer === void 0 ? void 0 : lecturer.photoKey) : "".concat((0,url_utils/* publicAssets */.VK)('/avatar.svg')),
          name: lecturer === null || lecturer === void 0 ? void 0 : lecturer.name,
          slug: lecturer === null || lecturer === void 0 ? void 0 : lecturer.slug
        }, key);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
      className: "".concat(isVisibleFullDescription ? 'long' : 'short'),
      dangerouslySetInnerHTML: {
        __html: description === null || description === void 0 ? void 0 : description.replace('<img ', '<img width="auto"')
      },
      id: "description"
    }), description && !hideLink && isLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)(DescriptionMoreLink, {
      onClick: function onClick() {
        return setIsVisibleFullDescription(!isVisibleFullDescription);
      },
      children: isVisibleFullDescription ? t('course.description.short') : t('course.description.long')
    })]
  });
};

/* harmony default export */ var TrainingDescription = (TrainingDescriptionTemplate);
// EXTERNAL MODULE: ./src/components/TrainingLecturer/TrainingLecturer.tsx + 1 modules
var TrainingLecturer = __webpack_require__(97422);
;// CONCATENATED MODULE: ./src/components/TrainingProgram/TrainingProgram.elements.tsx



var TrainingProgram_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingProgramelements__Wrapper",
  componentId: "sc-7pxqu1-0"
})(["font-size:", ";line-height:", ";li{padding-bottom:", ";}@media (min-width:", "px){padding:", " 0;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(4), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(20));
var TrainingProgram_elements_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "TrainingProgramelements__Title",
  componentId: "sc-7pxqu1-1"
})(["font-weight:", ";font-size:", ";padding:", " 0 ", " 0;display:block;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(25));
var Program = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingProgramelements__Program",
  componentId: "sc-7pxqu1-2"
})(["padding-bottom:", ";border-bottom:", ";line-height:", ";a,h4 span{color:", " !important;}"], (0,polished_esm/* rem */.hO)(20), function (props) {
  return props.withBorder ? "2px solid ".concat(props.theme.colors.secondaryGrey) : 'unset';
}, (0,polished_esm/* rem */.hO)(22), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
});
var Experience = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingProgramelements__Experience",
  componentId: "sc-7pxqu1-3"
})(["background:", ";padding:", ";margin-top:", ";border-radius:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.darkLight;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(8));
var Information = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingProgramelements__Information",
  componentId: "sc-7pxqu1-4"
})(["padding-bottom:", ";border-bottom:2px solid ", ";a{color:", ";}"], (0,polished_esm/* rem */.hO)(20), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.secondaryGrey;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.primary;
});
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react-image-lightbox/dist/index.es.js
var index_es = __webpack_require__(92879);
// EXTERNAL MODULE: ./node_modules/react-image-lightbox/style.css
var style = __webpack_require__(23955);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/StaticCarouselGallery/StaticCarouselGallery.elements.tsx



var StaticCarouselGallery_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StaticCarouselGalleryelements__Wrapper",
  componentId: "sc-190oil9-0"
})(["padding:", ";position:relative;"], (0,polished_esm/* rem */.hO)(20));
var Photos = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StaticCarouselGalleryelements__Photos",
  componentId: "sc-190oil9-1"
})(["padding:", " 0;max-width:", ";"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(800));
var PhotoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StaticCarouselGalleryelements__PhotoContainer",
  componentId: "sc-190oil9-2"
})([""]);
var Photo = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
  displayName: "StaticCarouselGalleryelements__Photo",
  componentId: "sc-190oil9-3"
})(["width:95%;height:auto;border-radius:", ";margin-right:", ";cursor:pointer;"], (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(10));
;// CONCATENATED MODULE: ./src/components/StaticCarouselGallery/StaticCarouselGallery.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var StaticCarouselGalleryTemplate = function StaticCarouselGalleryTemplate(_ref) {
  var images = _ref.images;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    responsive: [{
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false
      }
    }]
  };

  var _useState = (0,react.useState)(false),
      imgFocus = _useState[0],
      setImgFocus = _useState[1];

  var _useState2 = (0,react.useState)(0),
      imgIndex = _useState2[0],
      setImgIndex = _useState2[1];

  return (images === null || images === void 0 ? void 0 : images.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(StaticCarouselGallery_elements_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Photos, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, _objectSpread(_objectSpread({}, settings), {}, {
        children: images === null || images === void 0 ? void 0 : images.map(function (image, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(PhotoContainer, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Photo, {
              width: 0,
              height: 0,
              loader: function loader(_ref2) {
                var src = _ref2.src;
                return src;
              },
              src: image,
              onClick: function onClick() {
                setImgIndex(key);
                setImgFocus(true);
              }
            })
          }, key);
        })
      }))
    }), imgFocus && /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* default */.Z, {
      mainSrc: images[imgIndex],
      nextSrc: images[(imgIndex + 1) % images.length],
      prevSrc: images[(imgIndex + images.length - 1) % images.length],
      onCloseRequest: function onCloseRequest() {
        return setImgFocus(false);
      },
      onMovePrevRequest: function onMovePrevRequest() {
        return setImgIndex((imgIndex + images.length - 1) % images.length);
      },
      onMoveNextRequest: function onMoveNextRequest() {
        return setImgIndex((imgIndex + 1) % images.length);
      }
    })]
  });
};

/* harmony default export */ var StaticCarouselGallery = (StaticCarouselGalleryTemplate);
;// CONCATENATED MODULE: ./src/components/TrainingProgram/TrainingProgram.tsx









var TrainingProgramTemplate = function TrainingProgramTemplate(_ref) {
  var program = _ref.program,
      detail = _ref.detail,
      experience = _ref.experience,
      experienceGallery = _ref.experienceGallery;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var fStr = program === null || program === void 0 ? void 0 : program.match(/width="\s*(\d+)"/);
  var result = program;

  if (fStr) {
    result = program.replace(fStr[0], " width='auto' ");
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [experience && /*#__PURE__*/(0,jsx_runtime.jsx)(Experience, {
      dangerouslySetInnerHTML: {
        __html: experience
      }
    }), (experienceGallery === null || experienceGallery === void 0 ? void 0 : experienceGallery.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(StaticCarouselGallery, {
      images: experienceGallery === null || experienceGallery === void 0 ? void 0 : experienceGallery.map(function (photo) {
        return "".concat((0,constants/* getApiURL */.tU)(), "/media/course/static-gallery/").concat(photo);
      })
    }), (result || detail) && /*#__PURE__*/(0,jsx_runtime.jsxs)(TrainingProgram_elements_Wrapper, {
      children: [result && /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingProgram_elements_Title, {
        children: t('training.program.title')
      }), result && /*#__PURE__*/(0,jsx_runtime.jsx)(Program, {
        dangerouslySetInnerHTML: {
          __html: result
        },
        withBorder: !!detail
      }), detail && /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingProgram_elements_Title, {
        children: t('training.program.information')
      }), detail && /*#__PURE__*/(0,jsx_runtime.jsx)(Information, {
        dangerouslySetInnerHTML: {
          __html: detail
        }
      })]
    })]
  });
};

/* harmony default export */ var TrainingProgram = (TrainingProgramTemplate);
// EXTERNAL MODULE: ./src/components/Modal/Login/LoginModal.tsx + 1 modules
var LoginModal = __webpack_require__(2298);
// EXTERNAL MODULE: ./src/utils/time.utils.ts
var time_utils = __webpack_require__(775);
;// CONCATENATED MODULE: ./src/components/TrainingChapters/TrainingChapters.elements.tsx



var TrainingChapters_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingChapterselements__Wrapper",
  componentId: "sc-hpilh7-0"
})(["padding:", " 0;"], (0,polished_esm/* rem */.hO)(25));
var TrainingChapters_elements_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingChapterselements__Title",
  componentId: "sc-hpilh7-1"
})(["font-weight:", ";font-size:", ";display:block;padding-bottom:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(15), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.black;
});
var Capitols = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingChapterselements__Capitols",
  componentId: "sc-hpilh7-2"
})(["padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(40));
var Capitol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingChapterselements__Capitol",
  componentId: "sc-hpilh7-3"
})(["display:flex;flex-direction:row;color:", ";align-items:center;padding-top:", ";cursor:pointer;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.black;
}, (0,polished_esm/* rem */.hO)(10));
var CapitolTime = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingChapterselements__CapitolTime",
  componentId: "sc-hpilh7-4"
})(["width:", ";"], (0,polished_esm/* rem */.hO)(70));
var CapitolIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "TrainingChapterselements__CapitolIcon",
  componentId: "sc-hpilh7-5"
})(["padding:0 ", " 0 ", ";svg{width:", ";height:", ";path{fill:", ";}}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primary;
});
var CapitolTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingChapterselements__CapitolTitle",
  componentId: "sc-hpilh7-6"
})([""]);
;// CONCATENATED MODULE: ./src/components/TrainingChapters/TrainingChapters.tsx









var TrainingChaptersTemplate = function TrainingChaptersTemplate(_ref) {
  var chapters = _ref.chapters,
      videoKey = _ref.videoKey;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var movePlayTimeToSelectedPosition = function movePlayTimeToSelectedPosition(time) {
    var element = document.getElementById("video-".concat(videoKey));

    if (element) {
      element.currentTime = time;
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingChapters_elements_Wrapper, {
    children: (chapters === null || chapters === void 0 ? void 0 : chapters.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TrainingChapters_elements_Title, {
        children: "Kapitoly:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Capitols, {
        children: chapters === null || chapters === void 0 ? void 0 : chapters.map(function (chapter, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Capitol, {
            onClick: function onClick() {
              return movePlayTimeToSelectedPosition(chapter.time);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CapitolTime, {
              children: (0,time_utils/* secondsToHMS */.ki)(chapter.time)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CapitolIcon, {
              name: Icon/* Icons.Play */.PJ.Play
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CapitolTitle, {
              children: [key + 1, " ", chapter.title]
            })]
          }, key);
        })
      })]
    })
  });
};

/* harmony default export */ var TrainingChapters = (TrainingChaptersTemplate);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
;// CONCATENATED MODULE: ./src/components/TrainingMaterial/TrainingMaterial.elements.tsx



var TrainingMaterial_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingMaterialelements__Wrapper",
  componentId: "sc-tyzgcz-0"
})(["padding:", " 0;"], (0,polished_esm/* rem */.hO)(25));
var TrainingMaterial_elements_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingMaterialelements__Title",
  componentId: "sc-tyzgcz-1"
})(["font-weight:", ";font-size:", ";display:block;padding-bottom:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(15), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.black;
});
var TrainingMaterial_elements_Materials = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingMaterialelements__Materials",
  componentId: "sc-tyzgcz-2"
})([""]);
var TrainingMaterial_elements_Capitols = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingMaterialelements__Capitols",
  componentId: "sc-tyzgcz-3"
})(["padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(40));
var TrainingMaterial_elements_Capitol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingMaterialelements__Capitol",
  componentId: "sc-tyzgcz-4"
})(["display:flex;flex-direction:row;color:", ";align-items:center;padding-top:", ";cursor:pointer;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.black;
}, (0,polished_esm/* rem */.hO)(10));
var TrainingMaterial_elements_CapitolTime = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingMaterialelements__CapitolTime",
  componentId: "sc-tyzgcz-5"
})(["width:", ";"], (0,polished_esm/* rem */.hO)(70));
var TrainingMaterial_elements_CapitolIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "TrainingMaterialelements__CapitolIcon",
  componentId: "sc-tyzgcz-6"
})(["padding:0 ", " 0 ", ";svg{width:", ";height:", ";path{fill:", ";}}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primary;
});
var TrainingMaterial_elements_CapitolTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingMaterialelements__CapitolTitle",
  componentId: "sc-tyzgcz-7"
})([""]);
var Preview = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingMaterialelements__Preview",
  componentId: "sc-tyzgcz-8"
})(["display:flex;justify-content:center;"]);
var TrainingMaterial_elements_Material = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingMaterialelements__Material",
  componentId: "sc-tyzgcz-9"
})(["padding-top:", ";display:flex;cursor:pointer;"], (0,polished_esm/* rem */.hO)(10));
var TrainingMaterial_elements_MaterialIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "TrainingMaterialelements__MaterialIcon",
  componentId: "sc-tyzgcz-10"
})(["svg{width:", ";height:", ";}margin-right:", ";"], (0,polished_esm/* rem */.hO)(19), (0,polished_esm/* rem */.hO)(19), (0,polished_esm/* rem */.hO)(10));
var TrainingMaterial_elements_MaterialLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingMaterialelements__MaterialLabel",
  componentId: "sc-tyzgcz-11"
})(["color:", ";font-weight:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primary;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeights.textBold;
});
;// CONCATENATED MODULE: ./src/components/TrainingMaterial/TrainingMaterial.tsx










var TrainingMaterialTemplate = function TrainingMaterialTemplate(_ref) {
  var attachments = _ref.attachments;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingMaterial_elements_Wrapper, {
    children: (attachments === null || attachments === void 0 ? void 0 : attachments.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TrainingMaterial_elements_Title, {
        children: [t('training.materials.title'), ":"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingMaterial_elements_Materials, {
        children: attachments === null || attachments === void 0 ? void 0 : attachments.map(function (attachment, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(TrainingMaterial_elements_Material, {
            onClick: function onClick() {
              return (0,material_utils/* handleDownloadClick */.b)(attachment._key, attachment.filename);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TrainingMaterial_elements_MaterialIcon, {
              name: Icon/* Icons.File */.PJ.File
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingMaterial_elements_MaterialLabel, {
              children: attachment === null || attachment === void 0 ? void 0 : attachment.name
            })]
          }, key);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Preview, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          onClick: function onClick() {
            return attachments.map(function (attachment) {
              return (0,material_utils/* handleDownloadClick */.b)(attachment._key, attachment.filename, false, attachment.mime_type);
            });
          },
          marginTop: 25,
          text: t('material.download.all')
        })
      })]
    })
  });
};

/* harmony default export */ var TrainingMaterial = (TrainingMaterialTemplate);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./src/services/auth.service.ts
var auth_service = __webpack_require__(2586);
// EXTERNAL MODULE: ./src/services/calendar.service.ts
var calendar_service = __webpack_require__(2253);
// EXTERNAL MODULE: ./src/store/ui.ts
var ui = __webpack_require__(18770);
;// CONCATENATED MODULE: ./src/components/TrainingStream/TrainingStream.elements.tsx



var TrainingStream_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingStreamelements__Wrapper",
  componentId: "sc-10ihw3f-0"
})(["padding:", " 0 0 0;color:", ";line-height:", ";"], (0,polished_esm/* rem */.hO)(40), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(24));
var TabsBorderBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingStreamelements__TabsBorderBottom",
  componentId: "sc-10ihw3f-1"
})(["height:", ";background:", ";width:100%;position:absolute;bottom:0;"], (0,polished_esm/* rem */.hO)(2), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondaryGrey;
});
var Tabs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingStreamelements__Tabs",
  componentId: "sc-10ihw3f-2"
})(["display:flex;flex-direction:row;overflow:scroll;scrollbar-width:none;padding:", " 0 0 0;position:relative;&::-webkit-scrollbar{display:none;}"], (0,polished_esm/* rem */.hO)(20));
var Tab = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingStreamelements__Tab",
  componentId: "sc-10ihw3f-3"
})(["cursor:pointer;height:auto;color:", ";padding:0 ", " ", " ", ";line-height:", ";&.selected{color:", ";border-bottom:2px solid ", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(24), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primary;
});
var PlayerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingStreamelements__PlayerWrapper",
  componentId: "sc-10ihw3f-4"
})(["border-radius:", ";margin:", " 0;border:2px solid ", ";&.viewer{position:fixed;top:0;left:0;background-color:rgba(0,0,0,0.75);width:100vw;height:100vh;z-index:999999999;}iframe{border:none;}"], (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(25), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.darkLight;
});
var Player = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
  displayName: "TrainingStreamelements__Player",
  componentId: "sc-10ihw3f-5"
})(["width:100%;min-height:", ";&.viewer{width:90%;height:90%;margin:2.5% 5%;}"], (0,polished_esm/* rem */.hO)(500));
var PlayerCloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "TrainingStreamelements__PlayerCloseButton",
  componentId: "sc-10ihw3f-6"
})(["background:none;padding:0;border:none;cursor:pointer;color:white;top:", ";right:", ";position:fixed;font-weight:", ";z-index:999999999;"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(30), function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeights.textBold;
});
var OpenViewerButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "TrainingStreamelements__OpenViewerButton",
  componentId: "sc-10ihw3f-7"
})(["background:", ";border:none;cursor:pointer;color:", ";padding:", ";border-radius:", ";margin:0 auto;display:none;&:hover{opacity:0.9;}@media (min-width:", "px){display:block;}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.black;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(12), (0,polished_esm/* rem */.hO)(6), theme/* breakpoints.sm */.A.sm);
var NoLoggedIn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingStreamelements__NoLoggedIn",
  componentId: "sc-10ihw3f-8"
})(["background:", ";color:", ";padding:", " ", ";height:", ";text-align:center;border-radius:", ";margin:", " 0;display:flex;align-items:center;flex-direction:column;justify-content:center;"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.darkLight;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.black;
}, (0,polished_esm/* rem */.hO)(60), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(350), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(25));
var Zoom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingStreamelements__Zoom",
  componentId: "sc-10ihw3f-9"
})(["background:", ";color:", ";padding:", " ", ";border-radius:", ";margin:", " 0;height:", ";text-align:center;display:flex;align-items:center;flex-direction:column;justify-content:center;"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.darkLight;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.black;
}, (0,polished_esm/* rem */.hO)(60), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(350));
var Record = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingStreamelements__Record",
  componentId: "sc-10ihw3f-10"
})([""]);
var RecordPlayer = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
  displayName: "TrainingStreamelements__RecordPlayer",
  componentId: "sc-10ihw3f-11"
})(["width:100%;min-height:", ";position:relative;"], (0,polished_esm/* rem */.hO)(500));
var Message = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "TrainingStreamelements__Message",
  componentId: "sc-10ihw3f-12"
})(["margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(40));
;// CONCATENATED MODULE: ./src/components/TrainingStream/TrainingStream.tsx





















var STREAM_STATUS;

(function (STREAM_STATUS) {
  STREAM_STATUS["IS_ACTIVE"] = "active";
  STREAM_STATUS["IS_INACTIVE"] = "inactive";
})(STREAM_STATUS || (STREAM_STATUS = {}));

var TrainingStreamTemplate = function TrainingStreamTemplate(_ref) {
  var _activeDate$date7, _activeDate$streams5, _activeDate$date8, _activeDate$date9, _activeDate$date10, _activeDate$date11, _activeDate$videos4, _activeDate$videos5, _activeDate$date12, _activeDate$streams6, _activeDate$date13, _activeDate$streams7, _activeDate$streams7$, _activeDate$streams8, _activeDate$streams8$, _activeDate$date14, _activeDate$streams9, _activeDate$streams9$, _orderedVideos$, _activeDate$streams10, _activeDate$streams11, _activeDate$streams12, _activeDate$streams13, _activeDate$date15, _activeDate$attachmen, _activeDate$videos6, _activeDate$videos6$, _activeDate$videos6$$;

  var trainingDates = _ref.dates;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var dispatch = (0,es/* useDispatch */.I0)();
  var router = (0,next_router.useRouter)();
  var isLoggedInState = (0,es/* useSelector */.v9)(function (state) {
    return state.ui.isLoggedIn;
  });

  var _useState = (0,react.useState)(false),
      isLoggedIn = _useState[0],
      setIsLoggedIn = _useState[1];

  var _useState2 = (0,react.useState)([]),
      dates = _useState2[0],
      setDates = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      activeDate = _useState3[0],
      setActiveDate = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isWaitingOnRecord = _useState4[0],
      setIsWaitingOnRecord = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isViewerActive = _useState5[0],
      setIsViewerActive = _useState5[1];

  var _useState6 = (0,react.useState)([]),
      orderedVideos = _useState6[0],
      setOrderedVideos = _useState6[1];

  (0,react.useEffect)(function () {
    if ((trainingDates === null || trainingDates === void 0 ? void 0 : trainingDates.length) > 0) {
      var filteredDates = trainingDates.filter(function (date) {
        var _date$streams, _date$attachments, _date$videos;

        return ((_date$streams = date.streams) === null || _date$streams === void 0 ? void 0 : _date$streams.length) > 0 || ((_date$attachments = date.attachments) === null || _date$attachments === void 0 ? void 0 : _date$attachments.length) > 0 || ((_date$videos = date.videos) === null || _date$videos === void 0 ? void 0 : _date$videos.length) > 0;
      });
      setDates(filteredDates);
      setActiveDate((filteredDates === null || filteredDates === void 0 ? void 0 : filteredDates.find(function (date) {
        return date.date._key === router.query.termin;
      })) || (filteredDates === null || filteredDates === void 0 ? void 0 : filteredDates[0]));
    }
  }, [trainingDates]);
  (0,react.useEffect)(function () {
    setIsLoggedIn(isLoggedInState);
  }, [isLoggedInState]);
  (0,react.useEffect)(function () {
    var _activeDate$date, _activeDate$streams, _activeDate$videos, _activeDate$date2, _activeDate$streams2, _activeDate$videos2;

    if (moment_default()().local().diff(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$date = activeDate.date) === null || _activeDate$date === void 0 ? void 0 : _activeDate$date.to, 'minutes') > 0 && (activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$streams = activeDate.streams) === null || _activeDate$streams === void 0 ? void 0 : _activeDate$streams.length) === 0 && (activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$videos = activeDate.videos) === null || _activeDate$videos === void 0 ? void 0 : _activeDate$videos.length) === 0) {
      return setIsWaitingOnRecord(true);
    }

    if (moment_default()().local().diff(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$date2 = activeDate.date) === null || _activeDate$date2 === void 0 ? void 0 : _activeDate$date2.to, 'minutes') > 0 && (activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$streams2 = activeDate.streams) === null || _activeDate$streams2 === void 0 ? void 0 : _activeDate$streams2.length) > 0 && (activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$videos2 = activeDate.videos) === null || _activeDate$videos2 === void 0 ? void 0 : _activeDate$videos2.length) === 0) {
      var _activeDate$streams$;

      calendar_service/* calendarApi.getStreamStatus */.w.getStreamStatus(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$streams$ = activeDate.streams[0]) === null || _activeDate$streams$ === void 0 ? void 0 : _activeDate$streams$._key).then(function (_ref2) {
        var data = _ref2.data;

        if ((data === null || data === void 0 ? void 0 : data.status) === STREAM_STATUS.IS_INACTIVE) {
          setIsWaitingOnRecord(true);
        }
      });
    } else {
      setIsWaitingOnRecord(false);
    }

    setOrderedVideos(activeDate === null || activeDate === void 0 ? void 0 : activeDate.videos.sort(function (a, b) {
      return a.order - b.order;
    }));
  }, [activeDate]);
  (0,react.useEffect)(function () {
    orderedVideos === null || orderedVideos === void 0 ? void 0 : orderedVideos.map(function (video) {
      var element = document.getElementById("video-".concat(video._key));

      if (element) {
        element.setAttribute('controlslist', 'nodownload');
      }

      if (video && element) {
        element.currentTime = video === null || video === void 0 ? void 0 : video.timeWatched;
        element.addEventListener('pause', /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return calendar_service/* calendarApi.updateWatchedTimeToVideo */.w.updateWatchedTimeToVideo(video._key, element.currentTime);

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })));
      }
    });
  }, [orderedVideos]);
  (0,react.useEffect)(function () {
    setInterval(function () {
      var _activeDate$date3, _activeDate$streams3, _activeDate$streams3$, _activeDate$videos3;

      var countOfMinutesToStart = moment_default()().local().diff(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$date3 = activeDate.date) === null || _activeDate$date3 === void 0 ? void 0 : _activeDate$date3.from, 'minutes');

      if (countOfMinutesToStart >= -5 && !(activeDate !== null && activeDate !== void 0 && (_activeDate$streams3 = activeDate.streams) !== null && _activeDate$streams3 !== void 0 && (_activeDate$streams3$ = _activeDate$streams3[0]) !== null && _activeDate$streams3$ !== void 0 && _activeDate$streams3$.url) && (activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$videos3 = activeDate.videos) === null || _activeDate$videos3 === void 0 ? void 0 : _activeDate$videos3.length) === 0) {
        calendar_service/* calendarApi.getTrainingDates */.w.getTrainingDates(router.query.slug, js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY */.Wx)).then(function (_ref4) {
          var data = _ref4.data;
          var filteredDates = data === null || data === void 0 ? void 0 : data.filter(function (date) {
            var _date$streams2, _date$attachments2;

            return ((_date$streams2 = date.streams) === null || _date$streams2 === void 0 ? void 0 : _date$streams2.length) > 0 || ((_date$attachments2 = date.attachments) === null || _date$attachments2 === void 0 ? void 0 : _date$attachments2.length) > 0;
          });
          setDates(filteredDates);
        });
      }
    }, 60 * 1000);
  }, [activeDate]);
  (0,react.useEffect)(function () {
    var _activeDate$date4, _activeDate$date5, _activeDate$streams4;

    var element = document.getElementById('stream');
    var isRunning = moment_default()().local().diff(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$date4 = activeDate.date) === null || _activeDate$date4 === void 0 ? void 0 : _activeDate$date4.from, 'minutes') >= 0 && moment_default()().local().diff(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$date5 = activeDate.date) === null || _activeDate$date5 === void 0 ? void 0 : _activeDate$date5.to, 'minutes') <= 0;

    if (activeDate !== null && activeDate !== void 0 && activeDate.accessible && isRunning && activeDate !== null && activeDate !== void 0 && (_activeDate$streams4 = activeDate.streams) !== null && _activeDate$streams4 !== void 0 && _activeDate$streams4[0] && element) {
      setInterval( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _yield$authApi$refres, data, _error$response;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return auth_service/* authApi.refresh */.i.refresh(js_cookie/* default.get */.Z.get(constants/* REFRESH_TOKEN_KEY */.w4));

              case 3:
                _yield$authApi$refres = _context2.sent;
                data = _yield$authApi$refres.data;
                js_cookie/* default.set */.Z.set(constants/* ACCESS_TOKEN_KEY */.Wx, data.access_token);
                js_cookie/* default.set */.Z.set(constants/* REFRESH_TOKEN_KEY */.w4, data.refresh_token, {
                  expires: 3
                });
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);

                if ((_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_error$response = _context2.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401) {
                  js_cookie/* default.remove */.Z.remove(constants/* ACCESS_TOKEN_KEY */.Wx);
                  js_cookie/* default.remove */.Z.remove(constants/* REFRESH_TOKEN_KEY */.w4);
                  dispatch((0,ui/* setIsLoggedIn */.nf)(false));
                  router.push({
                    pathname: constants/* ROUTES.HOME */.Z6.HOME
                  });
                }

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 9]]);
      })), 10 * 60 * 1000);
    }
  }, [activeDate]);
  (0,react.useEffect)(function () {
    document.addEventListener('keyup', /*#__PURE__*/function () {
      var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(event) {
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                event.preventDefault();

                if (!(event.keyCode === LoginModal/* ESC_KEY_CODE */.zi)) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 4;
                return setIsViewerActive(false);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }());
  }, []);
  return (dates === null || dates === void 0 ? void 0 : dates.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(TrainingStream_elements_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Tabs, {
      children: [dates === null || dates === void 0 ? void 0 : dates.map(function (date, index) {
        var _activeDate$date6, _date$streams3;

        var formattedDateFrom = moment_default()(date.date.from).local().format('DD. MM. YYYY');
        var formattedDateTo = moment_default()(date.date.to).local().format('DD. MM. YYYY');
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Tab, {
          onClick: function onClick() {
            return setActiveDate(date);
          },
          className: (activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$date6 = activeDate.date) === null || _activeDate$date6 === void 0 ? void 0 : _activeDate$date6._key) === date.date._key ? 'selected' : '',
          children: [isLoggedIn && (date === null || date === void 0 ? void 0 : (_date$streams3 = date.streams) === null || _date$streams3 === void 0 ? void 0 : _date$streams3.length) === 0 ? '' : t('training.detail.stream.title'), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " (", formattedDateFrom, formattedDateTo && formattedDateFrom !== formattedDateTo ? " - ".concat(formattedDateTo) : '', ")"]
        }, index);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabsBorderBottom, {})]
    }), moment_default()().local().diff(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$date7 = activeDate.date) === null || _activeDate$date7 === void 0 ? void 0 : _activeDate$date7.from, 'minutes') <= -60 && (activeDate === null || activeDate === void 0 ? void 0 : activeDate.isOnline) && /*#__PURE__*/(0,jsx_runtime.jsxs)(NoLoggedIn, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Message, {
        children: t('training.detail.stream.waiting.message1')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Message, {
        children: t('training.detail.stream.waiting.message2')
      })]
    }), !isLoggedIn && !js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY_GUEST */.rj) && (activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$streams5 = activeDate.streams) === null || _activeDate$streams5 === void 0 ? void 0 : _activeDate$streams5.length) > 0 && moment_default()().local().diff(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$date8 = activeDate.date) === null || _activeDate$date8 === void 0 ? void 0 : _activeDate$date8.from, 'minutes') > -60 && !isWaitingOnRecord && moment_default()().local().diff(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$date9 = activeDate.date) === null || _activeDate$date9 === void 0 ? void 0 : _activeDate$date9.to, 'minutes') < 120 && /*#__PURE__*/(0,jsx_runtime.jsxs)(NoLoggedIn, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Message, {
        children: t('training.detail.stream.noLoggedIn.message1')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Message, {
        children: t('training.detail.stream.noLoggedIn.message2')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        marginTop: 20,
        onClick: function onClick() {
          return !isLoggedIn && dispatch((0,ui/* openModalType */.$X)({
            type: Modal/* ModalTypes.LOGIN */.Q.LOGIN
          }));
        },
        text: t('training.detail.button.loggedIn')
      })]
    }), (isLoggedIn || js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY_GUEST */.rj)) && activeDate && !(activeDate !== null && activeDate !== void 0 && activeDate.accessible) && moment_default()().local().diff(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$date10 = activeDate.date) === null || _activeDate$date10 === void 0 ? void 0 : _activeDate$date10.from, 'minutes') > -60 && !isWaitingOnRecord && moment_default()().local().diff(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$date11 = activeDate.date) === null || _activeDate$date11 === void 0 ? void 0 : _activeDate$date11.to, 'minutes') < 120 && /*#__PURE__*/(0,jsx_runtime.jsx)(NoLoggedIn, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Message, {
        children: t('training.detail.stream.noAccessible.message1')
      })
    }), !isLoggedIn && !js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY_GUEST */.rj) && (activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$videos4 = activeDate.videos) === null || _activeDate$videos4 === void 0 ? void 0 : _activeDate$videos4.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(NoLoggedIn, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Message, {
        children: t('training.detail.record.noLoggedIn.message1')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Message, {
        children: t('training.detail.record.noLoggedIn.message2')
      })]
    }), !isLoggedIn && !js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY_GUEST */.rj) && (activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$videos5 = activeDate.videos) === null || _activeDate$videos5 === void 0 ? void 0 : _activeDate$videos5.length) === 0 && (isWaitingOnRecord || moment_default()().local().diff(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$date12 = activeDate.date) === null || _activeDate$date12 === void 0 ? void 0 : _activeDate$date12.to, 'minutes') > 120) && /*#__PURE__*/(0,jsx_runtime.jsx)(NoLoggedIn, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Message, {
        children: t('training.detail.stream.cancelled.message1')
      })
    }), (isLoggedIn || js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY_GUEST */.rj)) && (activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$streams6 = activeDate.streams) === null || _activeDate$streams6 === void 0 ? void 0 : _activeDate$streams6.length) > 0 && (isWaitingOnRecord || moment_default()().local().diff(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$date13 = activeDate.date) === null || _activeDate$date13 === void 0 ? void 0 : _activeDate$date13.to, 'minutes') > 120) && /*#__PURE__*/(0,jsx_runtime.jsx)(NoLoggedIn, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Message, {
        children: t('training.detail.stream.cancelled.message1')
      })
    }), (activeDate === null || activeDate === void 0 ? void 0 : activeDate.accessible) && (activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$streams7 = activeDate.streams) === null || _activeDate$streams7 === void 0 ? void 0 : (_activeDate$streams7$ = _activeDate$streams7[0]) === null || _activeDate$streams7$ === void 0 ? void 0 : _activeDate$streams7$.room_id) && (activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$streams8 = activeDate.streams) === null || _activeDate$streams8 === void 0 ? void 0 : (_activeDate$streams8$ = _activeDate$streams8[0]) === null || _activeDate$streams8$ === void 0 ? void 0 : _activeDate$streams8$.url) && moment_default()().local().diff(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$date14 = activeDate.date) === null || _activeDate$date14 === void 0 ? void 0 : _activeDate$date14.from, 'minutes') > -60 && !isWaitingOnRecord && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PlayerWrapper, {
        className: isViewerActive ? 'viewer' : '',
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Player, {
          name: "studiow",
          target: "studiow",
          sandbox: "allow-forms allow-top-navigation allow-scripts allow-same-origin",
          src: activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$streams9 = activeDate.streams) === null || _activeDate$streams9 === void 0 ? void 0 : (_activeDate$streams9$ = _activeDate$streams9[0]) === null || _activeDate$streams9$ === void 0 ? void 0 : _activeDate$streams9$.url,
          className: isViewerActive ? 'viewer' : ''
        })
      }), isViewerActive && /*#__PURE__*/(0,jsx_runtime.jsx)(PlayerCloseButton, {
        onClick: function onClick() {
          return setIsViewerActive(false);
        },
        children: "\u2715"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OpenViewerButton, {
        onClick: function onClick() {
          return setIsViewerActive(true);
        },
        children: t('training.detail.stream.viewer.button')
      })]
    }), (activeDate === null || activeDate === void 0 ? void 0 : activeDate.accessible) && (orderedVideos === null || orderedVideos === void 0 ? void 0 : (_orderedVideos$ = orderedVideos[0]) === null || _orderedVideos$ === void 0 ? void 0 : _orderedVideos$.url) && (orderedVideos === null || orderedVideos === void 0 ? void 0 : orderedVideos.map(function (video, key) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Record, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(RecordPlayer, {
            id: "video-".concat(video._key),
            allow: "fullscreen",
            controls: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("source", {
              src: video === null || video === void 0 ? void 0 : video.url,
              type: "video/mp4"
            })
          })
        }, key), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingChapters, {
          chapters: video === null || video === void 0 ? void 0 : video.chapters,
          videoKey: "video-".concat(video._key)
        })]
      });
    })), (activeDate === null || activeDate === void 0 ? void 0 : activeDate.accessible) && !(activeDate !== null && activeDate !== void 0 && (_activeDate$streams10 = activeDate.streams) !== null && _activeDate$streams10 !== void 0 && (_activeDate$streams11 = _activeDate$streams10[0]) !== null && _activeDate$streams11 !== void 0 && _activeDate$streams11.room_id) && (activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$streams12 = activeDate.streams) === null || _activeDate$streams12 === void 0 ? void 0 : (_activeDate$streams13 = _activeDate$streams12[0]) === null || _activeDate$streams13 === void 0 ? void 0 : _activeDate$streams13.url) && moment_default()().local().diff(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$date15 = activeDate.date) === null || _activeDate$date15 === void 0 ? void 0 : _activeDate$date15.from, 'minutes') > -60 && moment_default()().local().diff(activeDate.date.to, 'minutes') <= 120 && /*#__PURE__*/(0,jsx_runtime.jsx)(Zoom, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        onClick: function onClick() {
          var _activeDate$streams14, _activeDate$streams15;

          return window.open(activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$streams14 = activeDate.streams) === null || _activeDate$streams14 === void 0 ? void 0 : (_activeDate$streams15 = _activeDate$streams14[0]) === null || _activeDate$streams15 === void 0 ? void 0 : _activeDate$streams15.url, '_blank');
        },
        text: t('training.detail.button.zoom')
      })
    }), (activeDate === null || activeDate === void 0 ? void 0 : activeDate.accessible) && ((activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$attachmen = activeDate.attachments) === null || _activeDate$attachmen === void 0 ? void 0 : _activeDate$attachmen.length) > 0 || (activeDate === null || activeDate === void 0 ? void 0 : (_activeDate$videos6 = activeDate.videos) === null || _activeDate$videos6 === void 0 ? void 0 : (_activeDate$videos6$ = _activeDate$videos6[0]) === null || _activeDate$videos6$ === void 0 ? void 0 : (_activeDate$videos6$$ = _activeDate$videos6$.chapters) === null || _activeDate$videos6$$ === void 0 ? void 0 : _activeDate$videos6$$.length) > 0) && /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingMaterial, {
      attachments: activeDate === null || activeDate === void 0 ? void 0 : activeDate.attachments
    })]
  });
};

/* harmony default export */ var TrainingStream = (TrainingStreamTemplate);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var SectionTitle_Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/utils/person.utils.ts
var person_utils = __webpack_require__(19033);
// EXTERNAL MODULE: ./src/interfaces/Calendar.ts
var Calendar = __webpack_require__(17923);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
;// CONCATENATED MODULE: ./src/components/Training/Training.elements.tsx





var DesktopTop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Trainingelements__DesktopTop",
  componentId: "sc-1qughfy-0"
})(["margin-top:", ";display:none;flex-direction:row;justify-content:space-between;gap:", ";@media (min-width:", "px){margin-top:", ";}@media (min-width:", "px){display:flex;}"], (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(25), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), theme/* breakpoints.md */.A.md);
var Training_elements_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Trainingelements__Content",
  componentId: "sc-1qughfy-1"
})(["padding:", " 0;width:100%;"], (0,polished_esm/* rem */.hO)(10));
var Banner = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Trainingelements__Banner",
  componentId: "sc-1qughfy-2"
})(["width:", ";border-radius:", ";cursor:pointer;"], (0,polished_esm/* rem */.hO)(320), (0,polished_esm/* rem */.hO)(16));
var Sidebar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Trainingelements__Sidebar",
  componentId: "sc-1qughfy-3"
})(["min-width:", ";max-width:", ";"], (0,polished_esm/* rem */.hO)(320), (0,polished_esm/* rem */.hO)(320));
var Mobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Trainingelements__Mobile",
  componentId: "sc-1qughfy-4"
})(["display:block;padding:", " ", ";margin-top:", ";@media (min-width:", "px){display:none;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), theme/* breakpoints.md */.A.md);
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Trainingelements__Header",
  componentId: "sc-1qughfy-5"
})(["display:flex;flex-direction:row;justify-content:space-between;align-items:flex-end;"]);
var Favourite = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Trainingelements__Favourite",
  componentId: "sc-1qughfy-6"
})(["font-size:", ";cursor:pointer;margin-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(5));
var FavouriteIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "Trainingelements__FavouriteIcon",
  componentId: "sc-1qughfy-7"
})(["svg{width:", ";height:", ";path{fill:", ";}}"], (0,polished_esm/* rem */.hO)(23), (0,polished_esm/* rem */.hO)(17), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
});
// EXTERNAL MODULE: ./src/ui/Package/Package.tsx + 1 modules
var Package = __webpack_require__(42420);
// EXTERNAL MODULE: ./src/constants/packages.ts
var constants_packages = __webpack_require__(31828);
;// CONCATENATED MODULE: ./src/components/TrainingPackage/TrainingPackage.elements.tsx


var TrainingPackage_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingPackageelements__Wrapper",
  componentId: "sc-hz6yu2-0"
})(["padding:", ";border:1px solid ", ";border-radius:", ";margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(25), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(15));
var TrainingPackage_elements_Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "TrainingPackageelements__Description",
  componentId: "sc-hz6yu2-1"
})(["line-height:", ";font-size:", ";margin:0;"], (0,polished_esm/* rem */.hO)(28), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h6;
});
var Group = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingPackageelements__Group",
  componentId: "sc-hz6yu2-2"
})(["font-weight:", ";font-size:", ";display:block;padding-bottom:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(10));
var Packages = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingPackageelements__Packages",
  componentId: "sc-hz6yu2-3"
})([""]);
var TrainingPackage_elements_Package = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingPackageelements__Package",
  componentId: "sc-hz6yu2-4"
})(["display:flex;margin-top:", ";"], (0,polished_esm/* rem */.hO)(10));
var Name = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingPackageelements__Name",
  componentId: "sc-hz6yu2-5"
})(["display:inline-block;margin-left:", ";font-size:", ";"], (0,polished_esm/* rem */.hO)(10), function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.textMedium;
});
;// CONCATENATED MODULE: ./src/components/TrainingPackage/TrainingPackage.tsx








var TrainingPackageTemplate = function TrainingPackageTemplate(_ref) {
  var modules = _ref.modules;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return (modules === null || modules === void 0 ? void 0 : modules.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(TrainingPackage_elements_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TrainingPackage_elements_Description, {
      children: [t('training.package.label'), " ", /*#__PURE__*/(0,jsx_runtime.jsxs)(Group, {
        children: [t('training.package.title'), ":"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Packages, {
      children: modules.map(function (module, key) {
        var subscriptionPackage = constants_packages/* SUBSCRIPTION_PACKAGES.find */.QG.find(function (subPackage) {
          return subPackage.key === module.module._key;
        });
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(TrainingPackage_elements_Package, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Package/* default */.Z, {
            color: subscriptionPackage.color,
            symbol: subscriptionPackage.icon
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Name, {
            children: subscriptionPackage.title
          })]
        }, key);
      })
    })]
  });
};

/* harmony default export */ var TrainingPackage = (TrainingPackageTemplate);
;// CONCATENATED MODULE: ./src/components/Training/Training.tsx































var TrainingTemplate = function TrainingTemplate(_ref) {
  var _training$lecturers, _training$lecturers2, _training$course3, _training$course4, _training$course5, _training$dates, _training$course6, _training$course7, _training$course8, _training$course9, _training$course10, _training$lecturers3, _training$course11, _training$course11$be, _training$course12, _training$course12$bo, _training$course13, _training$course13$sc, _training$course14, _training$course14$in, _training$attachments, _training$course15, _training$course16, _training$course17, _training$course18, _training$course19, _training$course20, _training$course21, _training$dates2, _training$course22, _training$course23, _training$course24, _training$course25, _training$course26, _training$course27, _training$course28, _training$course29, _training$course30, _training$lecturers4;

  var training = _ref.training;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState = (0,react.useState)(Calendar/* TrainingViewTypes.DESKTOP */.CY.DESKTOP),
      trainingVersion = _useState[0],
      setTrainingVersion = _useState[1];

  var _useState2 = (0,react.useState)(false),
      hasError = _useState2[0],
      setHasError = _useState2[1];

  var _useState3 = (0,react.useState)(training === null || training === void 0 ? void 0 : training.isFavorite),
      isFavorite = _useState3[0],
      setIsFavorite = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isLoggedIn = _useState4[0],
      setIsLoggedIn = _useState4[1];

  var isLoggedInState = (0,es/* useSelector */.v9)(function (state) {
    return state.ui.isLoggedIn;
  });
  (0,react.useEffect)(function () {
    if (window.innerWidth >= theme/* breakpoints.md */.A.md) {
      setTrainingVersion(Calendar/* TrainingViewTypes.DESKTOP */.CY.DESKTOP);
    }

    if (window.innerWidth < theme/* breakpoints.md */.A.md) {
      setTrainingVersion(Calendar/* TrainingViewTypes.MOBILE */.CY.MOBILE);
    }
  });
  (0,react.useEffect)(function () {
    setIsLoggedIn(isLoggedInState);
  }, [isLoggedInState]);
  var formattedLecturers = (training === null || training === void 0 ? void 0 : (_training$lecturers = training.lecturers) === null || _training$lecturers === void 0 ? void 0 : _training$lecturers.length) > 0 ? training === null || training === void 0 ? void 0 : (_training$lecturers2 = training.lecturers) === null || _training$lecturers2 === void 0 ? void 0 : _training$lecturers2.map(function (lecturer) {
    return {
      photoKey: lecturer.person.photo,
      name: (0,person_utils/* formatLecturerName */.v)(lecturer.person),
      slug: lecturer.person.slug
    };
  }) : [];

  var handleOnFavoriteClick = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _training$course, _training$course2;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setHasError(false);

              if (isLoggedIn) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", dispatch((0,ui/* openModalType */.$X)({
                type: Modal/* ModalTypes.LOGIN */.Q.LOGIN
              })));

            case 4:
              if (!isFavorite) {
                _context.next = 9;
                break;
              }

              _context.next = 7;
              return calendar_service/* calendarApi.deleteCourseFromFavourite */.w.deleteCourseFromFavourite(training === null || training === void 0 ? void 0 : (_training$course = training.course) === null || _training$course === void 0 ? void 0 : _training$course._key);

            case 7:
              _context.next = 11;
              break;

            case 9:
              _context.next = 11;
              return calendar_service/* calendarApi.addCourseToFavourite */.w.addCourseToFavourite(training === null || training === void 0 ? void 0 : (_training$course2 = training.course) === null || _training$course2 === void 0 ? void 0 : _training$course2._key);

            case 11:
              setIsFavorite(!isFavorite);
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              setHasError(true);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 14]]);
    }));

    return function handleOnFavoriteClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [hasError && /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
      type: Alert/* AlertTypes.error */.d.error,
      message: t('course.popular.error')
    }), trainingVersion === Calendar/* TrainingViewTypes.DESKTOP */.CY.DESKTOP && /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopTop, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Training_elements_Content, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Header, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_Title/* default */.C, {
              tagType: SectionTitle_Title/* TitleTagTypes.H1 */.Z.H1,
              withoutPadding: true,
              alignLeft: true,
              children: training === null || training === void 0 ? void 0 : (_training$course3 = training.course) === null || _training$course3 === void 0 ? void 0 : _training$course3.title
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Favourite, {
              onClick: handleOnFavoriteClick,
              "data-tooltip-id": "favourite-tooltip",
              "data-tooltip-content": isFavorite ? t('course.popular.remove') : t('course.popular.add'),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FavouriteIcon, {
                name: isFavorite ? Icon/* Icons.FavouriteFull */.PJ.FavouriteFull : Icon/* Icons.Favourite */.PJ.Favourite
              }), ' ']
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalTooltipTemplate, {})]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingDescription, {
            lecturers: formattedLecturers,
            description: training === null || training === void 0 ? void 0 : (_training$course4 = training.course) === null || _training$course4 === void 0 ? void 0 : _training$course4.annotation,
            courseKey: training === null || training === void 0 ? void 0 : (_training$course5 = training.course) === null || _training$course5 === void 0 ? void 0 : _training$course5._key
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingDates/* default */.Z, {
            dates: training === null || training === void 0 ? void 0 : (_training$dates = training.dates) === null || _training$dates === void 0 ? void 0 : _training$dates.filter(function (date) {
              var _date$date;

              return moment_default()().local().diff(date === null || date === void 0 ? void 0 : (_date$date = date.date) === null || _date$date === void 0 ? void 0 : _date$date.to, 'minutes') <= 0;
            }),
            isCustom: !!(training !== null && training !== void 0 && (_training$course6 = training.course) !== null && _training$course6 !== void 0 && _training$course6.custom),
            modules: training === null || training === void 0 ? void 0 : training.modules
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingStream, {
            dates: training === null || training === void 0 ? void 0 : training.dates
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingProgram, {
            program: training === null || training === void 0 ? void 0 : (_training$course7 = training.course) === null || _training$course7 === void 0 ? void 0 : _training$course7.program,
            detail: training === null || training === void 0 ? void 0 : (_training$course8 = training.course) === null || _training$course8 === void 0 ? void 0 : _training$course8.detail,
            experience: training === null || training === void 0 ? void 0 : (_training$course9 = training.course) === null || _training$course9 === void 0 ? void 0 : _training$course9.experience_description,
            experienceGallery: training === null || training === void 0 ? void 0 : (_training$course10 = training.course) === null || _training$course10 === void 0 ? void 0 : _training$course10.static_gallery
          }), training === null || training === void 0 ? void 0 : (_training$lecturers3 = training.lecturers) === null || _training$lecturers3 === void 0 ? void 0 : _training$lecturers3.map(function (lecturer, key) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingLecturer/* default */.Z, {
              lecturer: lecturer.person,
              openedCourseId: training.course._id
            }, key);
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Support/* default */.Z, {
            withoutMargin: true
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Sidebar, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TrainingPackage, {
            modules: training === null || training === void 0 ? void 0 : training.modules
          }), ((training === null || training === void 0 ? void 0 : (_training$course11 = training.course) === null || _training$course11 === void 0 ? void 0 : (_training$course11$be = _training$course11.benefits) === null || _training$course11$be === void 0 ? void 0 : _training$course11$be.length) > 0 || (training === null || training === void 0 ? void 0 : (_training$course12 = training.course) === null || _training$course12 === void 0 ? void 0 : (_training$course12$bo = _training$course12.bonuses) === null || _training$course12$bo === void 0 ? void 0 : _training$course12$bo.length) > 0 || (training === null || training === void 0 ? void 0 : (_training$course13 = training.course) === null || _training$course13 === void 0 ? void 0 : (_training$course13$sc = _training$course13.schedule) === null || _training$course13$sc === void 0 ? void 0 : _training$course13$sc.length) > 0 || (training === null || training === void 0 ? void 0 : (_training$course14 = training.course) === null || _training$course14 === void 0 ? void 0 : (_training$course14$in = _training$course14.instructions) === null || _training$course14$in === void 0 ? void 0 : _training$course14$in.length) > 0 || (training === null || training === void 0 ? void 0 : (_training$attachments = training.attachments) === null || _training$attachments === void 0 ? void 0 : _training$attachments.length) > 0) && /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingBenefit, {
            benefits: training === null || training === void 0 ? void 0 : (_training$course15 = training.course) === null || _training$course15 === void 0 ? void 0 : _training$course15.benefits,
            bonuses: training === null || training === void 0 ? void 0 : (_training$course16 = training.course) === null || _training$course16 === void 0 ? void 0 : _training$course16.bonuses,
            harmonogram: training === null || training === void 0 ? void 0 : (_training$course17 = training.course) === null || _training$course17 === void 0 ? void 0 : _training$course17.schedule,
            instructions: training === null || training === void 0 ? void 0 : (_training$course18 = training.course) === null || _training$course18 === void 0 ? void 0 : _training$course18.instructions,
            instructionAttachments: training === null || training === void 0 ? void 0 : training.attachments
          })]
        })]
      })
    }), trainingVersion === Calendar/* TrainingViewTypes.MOBILE */.CY.MOBILE && /*#__PURE__*/(0,jsx_runtime.jsxs)(Mobile, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Header, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle_Title/* default */.C, {
          tagType: SectionTitle_Title/* TitleTagTypes.H1 */.Z.H1,
          withoutPadding: true,
          alignLeft: true,
          children: training === null || training === void 0 ? void 0 : (_training$course19 = training.course) === null || _training$course19 === void 0 ? void 0 : _training$course19.title
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Favourite, {
          onClick: handleOnFavoriteClick,
          "data-tooltip-id": "favourite-tooltip",
          "data-tooltip-content": isFavorite ? t('course.popular.remove') : t('course.popular.add'),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FavouriteIcon, {
            name: isFavorite ? Icon/* Icons.FavouriteFull */.PJ.FavouriteFull : Icon/* Icons.Favourite */.PJ.Favourite
          }), ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalTooltipTemplate, {})]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingDescription, {
        lecturers: formattedLecturers,
        description: training === null || training === void 0 ? void 0 : (_training$course20 = training.course) === null || _training$course20 === void 0 ? void 0 : _training$course20.annotation,
        courseKey: training === null || training === void 0 ? void 0 : (_training$course21 = training.course) === null || _training$course21 === void 0 ? void 0 : _training$course21._key,
        isFavorite: training === null || training === void 0 ? void 0 : training.isFavorite
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingPackage, {
        modules: training === null || training === void 0 ? void 0 : training.modules
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingDates/* default */.Z, {
        dates: training === null || training === void 0 ? void 0 : (_training$dates2 = training.dates) === null || _training$dates2 === void 0 ? void 0 : _training$dates2.filter(function (date) {
          var _date$date2;

          return moment_default()().local().diff(date === null || date === void 0 ? void 0 : (_date$date2 = date.date) === null || _date$date2 === void 0 ? void 0 : _date$date2.to, 'minutes') <= 0;
        }),
        isCustom: !!(training !== null && training !== void 0 && (_training$course22 = training.course) !== null && _training$course22 !== void 0 && _training$course22.custom),
        modules: training === null || training === void 0 ? void 0 : training.modules
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingStream, {
        dates: training === null || training === void 0 ? void 0 : training.dates
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingProgram, {
        program: training === null || training === void 0 ? void 0 : (_training$course23 = training.course) === null || _training$course23 === void 0 ? void 0 : _training$course23.program,
        detail: training === null || training === void 0 ? void 0 : (_training$course24 = training.course) === null || _training$course24 === void 0 ? void 0 : _training$course24.detail,
        experience: training === null || training === void 0 ? void 0 : (_training$course25 = training.course) === null || _training$course25 === void 0 ? void 0 : _training$course25.experience_description,
        experienceGallery: training === null || training === void 0 ? void 0 : (_training$course26 = training.course) === null || _training$course26 === void 0 ? void 0 : _training$course26.static_gallery
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingBenefit, {
        benefits: training === null || training === void 0 ? void 0 : (_training$course27 = training.course) === null || _training$course27 === void 0 ? void 0 : _training$course27.benefits,
        bonuses: training === null || training === void 0 ? void 0 : (_training$course28 = training.course) === null || _training$course28 === void 0 ? void 0 : _training$course28.bonuses,
        harmonogram: training === null || training === void 0 ? void 0 : (_training$course29 = training.course) === null || _training$course29 === void 0 ? void 0 : _training$course29.schedule,
        instructions: training === null || training === void 0 ? void 0 : (_training$course30 = training.course) === null || _training$course30 === void 0 ? void 0 : _training$course30.instructions,
        instructionAttachments: training === null || training === void 0 ? void 0 : training.attachments
      }), training === null || training === void 0 ? void 0 : (_training$lecturers4 = training.lecturers) === null || _training$lecturers4 === void 0 ? void 0 : _training$lecturers4.map(function (lecturer, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(TrainingLecturer/* default */.Z, {
          lecturer: lecturer.person,
          openedCourseId: training.course._id
        }, key);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Support/* default */.Z, {})]
    })]
  });
};

/* harmony default export */ var Training = (TrainingTemplate);

/***/ }),

/***/ 97422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TrainingLecturer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/services/lecturer.service.ts
var lecturer_service = __webpack_require__(4034);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/TrainingLecturer/TrainingLecturer.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__Wrapper",
  componentId: "sc-1258wxd-0"
})(["margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(40));
var Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingLecturerelements__Title",
  componentId: "sc-1258wxd-1"
})(["display:block;font-weight:", ";font-size:", ";background:", ";padding:", " 0 ", " 0;border-top-left-radius:", ";border-top-right-radius:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (prop) {
  return prop.withoutBackground ? prop.theme.colors.white : prop.theme.colors.darkLight;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(35), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(8));
var SubTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "TrainingLecturerelements__SubTitle",
  componentId: "sc-1258wxd-2"
})(["font-size:", ";font-weight:", ";padding-bottom:", ";display:block;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h5;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(15));
var Lecturer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__Lecturer",
  componentId: "sc-1258wxd-3"
})(["padding:", " 0;display:flex;flex-direction:column;", ";border-bottom-left-radius:", ";border-bottom-right-radius:", ";@media (min-width:", "px){flex-direction:row;}"], (0,polished_esm/* rem */.hO)(25), function (prop) {
  return prop.withBackground ? "background: ".concat(prop.theme.colors.darkLight, ";") : '';
}, (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(8), theme/* breakpoints.sm */.A.sm);
var Information = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__Information",
  componentId: "sc-1258wxd-4"
})(["padding-top:", ";@media (min-width:", "px){padding:0 ", ";}"], (0,polished_esm/* rem */.hO)(25), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(25));
var Position = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "TrainingLecturerelements__Position",
  componentId: "sc-1258wxd-5"
})(["font-weight:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
});
var Mail = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "TrainingLecturerelements__Mail",
  componentId: "sc-1258wxd-6"
})(["font-weight:", ";display:block;margin-top:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(10));
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "TrainingLecturerelements__Description",
  componentId: "sc-1258wxd-7"
})(["font-size:", ";line-height:", ";color:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(30), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grey;
});
var ImageSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__ImageSection",
  componentId: "sc-1258wxd-8"
})([""]);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "TrainingLecturerelements__Image",
  componentId: "sc-1258wxd-9"
})(["width:", ";height:auto;"], (0,polished_esm/* rem */.hO)(120));
var Name = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TrainingLecturerelements__Name",
  componentId: "sc-1258wxd-10"
})(["font-weight:", ";font-size:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeights.textBold;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSizes.h5;
});
var Events = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__Events",
  componentId: "sc-1258wxd-11"
})(["padding:", " 0;border-bottom:1px solid ", ";"], (0,polished_esm/* rem */.hO)(35), function (prop) {
  return prop.withoutBorder ? prop.theme.colors.white : prop.theme.colors.secondaryGrey;
});
var Event = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__Event",
  componentId: "sc-1258wxd-12"
})(["display:flex;flex-direction:row;flex-wrap:wrap;cursor:pointer;margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(8));
var EventDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__EventDate",
  componentId: "sc-1258wxd-13"
})(["padding-top:", ";padding-right:", ";width:", ";"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(250));
var EventName = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "TrainingLecturerelements__EventName",
  componentId: "sc-1258wxd-14"
})(["color:", ";background:none;padding:", " 0 0 0;cursor:pointer;border:0;text-align:left;margin-bottom:", ";-webkit-box-flex:0;flex:0 0 66.666667%;max-width:66.666667%;@media (max-width:", "px){flex:0 0 100%;max-width:100%;}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(5), theme/* breakpoints.sm */.A.sm);
var Archives = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrainingLecturerelements__Archives",
  componentId: "sc-1258wxd-15"
})(["padding:", " ", ";border-bottom:1px solid ", ";display:flex;flex-direction:column;"], (0,polished_esm/* rem */.hO)(35), (0,polished_esm/* rem */.hO)(25), function (prop) {
  return prop.withoutBorder ? prop.theme.colors.white : prop.theme.colors.secondaryGrey;
});
var ArchiveName = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "TrainingLecturerelements__ArchiveName",
  componentId: "sc-1258wxd-16"
})(["color:", ";background:none;padding:", " 0 0 0;text-align:left;cursor:pointer;border:0;"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(5));
var MoreLink = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "TrainingLecturerelements__MoreLink",
  componentId: "sc-1258wxd-17"
})(["background:none;border:none;cursor:pointer;padding:0;color:", ";font-size:", ";text-align:left;margin-top:", ";display:flex;flex-direction:row;text-decoration:underline;svg{width:", ";height:", ";transform:rotate(-90deg);}"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.primary;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(10));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/TrainingLecturer/TrainingLecturer.tsx












var PARTS;

(function (PARTS) {
  PARTS["TRAININGS"] = "trainings";
  PARTS["CONFERENCES"] = "conferences";
  PARTS["RECORDS"] = "records";
})(PARTS || (PARTS = {}));

var LIMIT_OF_EVENTS_PER_PAGE = 3;

var TrainingLecturerTemplate = function TrainingLecturerTemplate(_ref) {
  var _lecturer$titles, _lecturer$titles2, _lecturer$titles3, _lecturer$titles4;

  var _ref$isDetailPage = _ref.isDetailPage,
      isDetailPage = _ref$isDetailPage === void 0 ? false : _ref$isDetailPage,
      lecturer = _ref.lecturer,
      openedCourseId = _ref.openedCourseId;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)([]),
      upcomingTrainings = _useState[0],
      setUpcomingTrainings = _useState[1];

  var _useState2 = (0,react.useState)(0),
      upcomingTrainingsCount = _useState2[0],
      setUpcomingTrainingsCount = _useState2[1];

  var _useState3 = (0,react.useState)(3),
      upcomingTrainingsLimit = _useState3[0],
      setUpcomingTrainingsLimit = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      upcomingConferences = _useState4[0],
      setUpcomingConferences = _useState4[1];

  var _useState5 = (0,react.useState)(0),
      upcomingConferencesCount = _useState5[0],
      setUpcomingConferencesCount = _useState5[1];

  var _useState6 = (0,react.useState)(3),
      upcomingConferencesLimit = _useState6[0],
      setUpcomingConferencesLimit = _useState6[1];

  var _useState7 = (0,react.useState)([]),
      records = _useState7[0],
      setRecords = _useState7[1];

  var _useState8 = (0,react.useState)(0),
      recordsCount = _useState8[0],
      setRecordsCount = _useState8[1];

  var _useState9 = (0,react.useState)(3),
      recordsLimit = _useState9[0],
      setRecordsLimit = _useState9[1];

  var handleShowMoreClick = function handleShowMoreClick(part) {
    if (part === PARTS.TRAININGS) {
      lecturer_service/* lecturerApi.upcomingTrainings */.r.upcomingTrainings(lecturer.slug, upcomingTrainingsLimit + LIMIT_OF_EVENTS_PER_PAGE, 0).then(function (_ref2) {
        var data = _ref2.data;
        setUpcomingTrainings(data === null || data === void 0 ? void 0 : data.results);
        setUpcomingTrainingsCount(data === null || data === void 0 ? void 0 : data.total_count);
        setUpcomingTrainingsLimit(upcomingTrainingsLimit + LIMIT_OF_EVENTS_PER_PAGE);
      });
    }

    if (part === PARTS.CONFERENCES) {
      lecturer_service/* lecturerApi.upcomingConferences */.r.upcomingConferences(lecturer.slug, recordsLimit + LIMIT_OF_EVENTS_PER_PAGE, 0).then(function (_ref3) {
        var data = _ref3.data;
        setUpcomingConferences(data === null || data === void 0 ? void 0 : data.results);
        setUpcomingConferencesCount(data === null || data === void 0 ? void 0 : data.total_count);
        setUpcomingConferencesLimit(recordsLimit + LIMIT_OF_EVENTS_PER_PAGE);
      });
    }

    if (part === PARTS.RECORDS) {
      lecturer_service/* lecturerApi.records */.r.records(lecturer.slug, recordsLimit + LIMIT_OF_EVENTS_PER_PAGE, 0).then(function (_ref4) {
        var data = _ref4.data;
        setRecords(data === null || data === void 0 ? void 0 : data.results);
        setRecordsCount(data === null || data === void 0 ? void 0 : data.total_count);
        setRecordsLimit(recordsLimit + LIMIT_OF_EVENTS_PER_PAGE);
      });
    }
  };

  (0,react.useEffect)(function () {
    lecturer_service/* lecturerApi.upcomingTrainings */.r.upcomingTrainings(lecturer.slug, upcomingTrainingsLimit, 0, openedCourseId ? [openedCourseId] : []).then(function (_ref5) {
      var data = _ref5.data;
      setUpcomingTrainings(data === null || data === void 0 ? void 0 : data.results);
      setUpcomingTrainingsCount(data === null || data === void 0 ? void 0 : data.total_count);
    });
    lecturer_service/* lecturerApi.upcomingConferences */.r.upcomingConferences(lecturer.slug, upcomingConferencesLimit, 0).then(function (_ref6) {
      var data = _ref6.data;
      setUpcomingConferences(data === null || data === void 0 ? void 0 : data.results);
      setUpcomingConferencesCount(data === null || data === void 0 ? void 0 : data.total_count);
    });
    lecturer_service/* lecturerApi.records */.r.records(lecturer.slug, recordsLimit, 0, openedCourseId ? [openedCourseId] : []).then(function (_ref7) {
      var data = _ref7.data;
      setRecords(data === null || data === void 0 ? void 0 : data.results);
      setRecordsCount(data === null || data === void 0 ? void 0 : data.total_count);
    });
  }, []);

  var formatEventDate = function formatEventDate(from, to) {
    var formattedFrom = moment_default()(from);
    var formattedTo = moment_default()(to);
    return formattedTo.diff(formattedFrom, 'days') > 0 ? "".concat(moment_default()(from).format('DD. MM. YYYY'), " - ").concat(moment_default()(to).format('DD. MM. YYYY')) : moment_default()(from).format('DD. MM. YYYY');
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      withoutBackground: true,
      children: t('training.lecturer.title')
    }), lecturer && /*#__PURE__*/(0,jsx_runtime.jsxs)(Lecturer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageSection, {
        children: lecturer !== null && lecturer !== void 0 && lecturer.photo ? /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
          src: "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/people/").concat(lecturer._key)
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
          src: "".concat((0,url_utils/* publicAssets */.VK)('/avatar.svg'))
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Information, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Name, {
          children: [(_lecturer$titles = lecturer.titles) !== null && _lecturer$titles !== void 0 && _lecturer$titles.before_name ? "".concat((_lecturer$titles2 = lecturer.titles) === null || _lecturer$titles2 === void 0 ? void 0 : _lecturer$titles2.before_name, " ") : '', lecturer.name, " ", lecturer.surname, (_lecturer$titles3 = lecturer.titles) !== null && _lecturer$titles3 !== void 0 && _lecturer$titles3.after_name ? " ".concat((_lecturer$titles4 = lecturer.titles) === null || _lecturer$titles4 === void 0 ? void 0 : _lecturer$titles4.after_name) : '']
        }), lecturer.position && /*#__PURE__*/(0,jsx_runtime.jsx)(Position, {
          children: lecturer.position
        }), lecturer.email && lecturer.email !== 'undefined' && /*#__PURE__*/(0,jsx_runtime.jsx)(Mail, {
          href: "mailto:".concat(lecturer.email),
          children: lecturer.email
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
          dangerouslySetInnerHTML: {
            __html: lecturer.annotation
          }
        })]
      })]
    }), upcomingTrainingsCount > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Events, {
      withoutBorder: upcomingConferencesCount === 0,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubTitle, {
        children: t('training.lecturer.trainings')
      }), upcomingTrainings === null || upcomingTrainings === void 0 ? void 0 : upcomingTrainings.map(function (event) {
        var _event$eventDate;

        return (_event$eventDate = event.eventDate) === null || _event$eventDate === void 0 ? void 0 : _event$eventDate.map(function (date, key) {
          var _date$venues, _date$venues$, _date$venues2, _date$venues2$;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Event, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(EventDate, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: formatEventDate(date.eventDate.from, date.eventDate.to)
              }), " |", ' ', date.isOnline ? 'Online' : ((_date$venues = date.venues) === null || _date$venues === void 0 ? void 0 : (_date$venues$ = _date$venues[0]) === null || _date$venues$ === void 0 ? void 0 : _date$venues$.city) || ((_date$venues2 = date.venues) === null || _date$venues2 === void 0 ? void 0 : (_date$venues2$ = _date$venues2[0]) === null || _date$venues2$ === void 0 ? void 0 : _date$venues2$.name)]
            }, key), /*#__PURE__*/(0,jsx_runtime.jsx)(EventName, {
              onClick: function onClick() {
                return router.push({
                  pathname: "".concat(constants/* ROUTES.TRAINING */.Z6.TRAINING, "/").concat(event.course.slug)
                });
              },
              children: event.course.title
            })]
          }, key);
        });
      }), (upcomingTrainings === null || upcomingTrainings === void 0 ? void 0 : upcomingTrainings.length) < upcomingTrainingsCount && /*#__PURE__*/(0,jsx_runtime.jsx)(MoreLink, {
        onClick: function onClick() {
          return handleShowMoreClick(PARTS.TRAININGS);
        },
        children: t('training.lecturer.showMore')
      })]
    }), upcomingConferencesCount > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Events, {
      withoutBorder: recordsCount === 0,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubTitle, {
        children: t('training.lecturer.conferences')
      }), upcomingConferences === null || upcomingConferences === void 0 ? void 0 : upcomingConferences.map(function (event) {
        var _event$eventDate2;

        return (_event$eventDate2 = event.eventDate) === null || _event$eventDate2 === void 0 ? void 0 : _event$eventDate2.map(function (date, key) {
          var _date$venues3, _date$venues3$, _date$venues4, _date$venues4$;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Event, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(EventDate, {
              children: [formatEventDate(date.eventDate.from, date.eventDate.to), " |", ' ', ((_date$venues3 = date.venues) === null || _date$venues3 === void 0 ? void 0 : (_date$venues3$ = _date$venues3[0]) === null || _date$venues3$ === void 0 ? void 0 : _date$venues3$.city) || ((_date$venues4 = date.venues) === null || _date$venues4 === void 0 ? void 0 : (_date$venues4$ = _date$venues4[0]) === null || _date$venues4$ === void 0 ? void 0 : _date$venues4$.name)]
            }, key), /*#__PURE__*/(0,jsx_runtime.jsx)(EventName, {
              onClick: function onClick() {
                return router.push({
                  pathname: "".concat(constants/* ROUTES.CONFERENCE */.Z6.CONFERENCE, "/").concat(event.conference.slug)
                });
              },
              children: event.conference.title
            })]
          }, key);
        });
      }), (upcomingConferences === null || upcomingConferences === void 0 ? void 0 : upcomingConferences.length) < upcomingConferencesCount && /*#__PURE__*/(0,jsx_runtime.jsxs)(MoreLink, {
        onClick: function onClick() {
          return handleShowMoreClick(PARTS.CONFERENCES);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
          name: Icon/* Icons.ArrowDown */.PJ.ArrowDown
        }), " ", t('training.lecturer.showMore')]
      })]
    }), recordsCount > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Archives, {
      withoutBorder: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubTitle, {
        children: t('training.lecturer.records')
      }), records === null || records === void 0 ? void 0 : records.map(function (event, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ArchiveName, {
          onClick: function onClick() {
            return router.push({
              pathname: "".concat(constants/* ROUTES.TRAINING */.Z6.TRAINING, "/").concat(event.course.slug)
            });
          },
          children: event.course.title
        }, key);
      }), (records === null || records === void 0 ? void 0 : records.length) < recordsCount && /*#__PURE__*/(0,jsx_runtime.jsxs)(MoreLink, {
        onClick: function onClick() {
          return handleShowMoreClick(PARTS.RECORDS);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
          name: Icon/* Icons.ArrowDown */.PJ.ArrowDown
        }), " ", t('training.lecturer.showMore')]
      })]
    })]
  });
};

/* harmony default export */ var TrainingLecturer = (TrainingLecturerTemplate);

/***/ }),

/***/ 63102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InaccessibleErrorForGuest; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/UnaccessibleErrorForGuest/InaccessibleErrorForGuest.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InaccessibleErrorForGuestelements__Wrapper",
  componentId: "sc-86u53l-0"
})(["margin-top:", ";padding:", " 0;@media (min-width:", "px){margin-top:", ";}"], (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf));
var Message = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "InaccessibleErrorForGuestelements__Message",
  componentId: "sc-86u53l-1"
})(["display:block;padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(40));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/UnaccessibleErrorForGuest/InaccessibleErrorForGuest.tsx











var InaccessibleErrorForGuestTemplate = function InaccessibleErrorForGuestTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Message, {
        children: t('guest.error.noAccessible.message')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        text: t('guest.error.noAccessible.button'),
        onClick: function onClick() {
          js_cookie/* default.remove */.Z.remove(constants/* ACCESS_TOKEN_KEY_GUEST */.rj);
          js_cookie/* default.remove */.Z.remove(constants/* REFRESH_TOKEN_KEY_GUEST */.wS);
          router.push({
            pathname: constants/* ROUTES.HOME */.Z6.HOME
          });
        }
      })]
    })
  });
};

/* harmony default export */ var InaccessibleErrorForGuest = (InaccessibleErrorForGuestTemplate);

/***/ }),

/***/ 31828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GP": function() { return /* binding */ SUBSCRIPTION_PACKAGES_KEYS; },
/* harmony export */   "QG": function() { return /* binding */ SUBSCRIPTION_PACKAGES; }
/* harmony export */ });
/* unused harmony export SUBSCRIPTION_PACKAGES_KEYS_ENUM */
var SUBSCRIPTION_PACKAGES = [{
  title: 'Daně a účetnictví',
  key: 'taxes',
  moduleId: 'taxes',
  color: '#F2941A',
  saleBoxBackground: '#FAEFE1',
  redirectLink: 'https://studiow.cz/kurzy?kurz_typ=aktualne&rocni_predplatne=taxes',
  icon: 'D',
  benefits: ['<span class="bold">80+</span> nových webinářů každý rok', '<span class="bold">TOP lektoři</span> zodpovídají vaše dotazy', 'Archiv všech <span class="bold">videozáznamů</span>', '<span class="bold">Školicí materiály</span> ke stažení', '1 licence <span class="bold">pro 5 osob</span>', 'Exkluzivní webináře navíc'],
  price: '14 157',
  priceWithoutVat: '11 700'
}, {
  title: 'Mzdy, pracovní právo a personalistika',
  key: 'wages',
  moduleId: 'wages',
  color: '#F00035',
  saleBoxBackground: '#F7DADA',
  redirectLink: 'https://studiow.cz/kurzy?kurz_typ=aktualne&rocni_predplatne=wages',
  icon: 'M',
  benefits: ['<span class="bold">80+</span> nových webinářů každý rok', '<span class="bold">TOP lektoři</span> zodpovídají vaše dotazy', 'Archiv všech <span class="bold">videozáznamů</span>', '<span class="bold">Školicí materiály</span> ke stažení', '1 licence <span class="bold">pro 5 osob</span>', 'Exkluzivní webináře navíc'],
  price: '14 157',
  priceWithoutVat: '11 700'
}, {
  title: 'Veřejná správa',
  key: 'government',
  moduleId: 'government',
  color: '#63BF4D',
  saleBoxBackground: '#E7F5E4',
  redirectLink: 'https://studiow.cz/kurzy?kurz_typ=aktualne&rocni_predplatne=government',
  icon: 'V',
  benefits: ['<span class="bold">30+</span> nových webinářů každý rok', '<span class="bold">TOP lektoři</span> zodpovídají vaše dotazy', 'Archiv všech <span class="bold">videozáznamů</span>', '<span class="bold">Školicí materiály</span> ke stažení', '1 licence <span class="bold">pro 5 osob</span>', 'Exkluzivní webináře navíc'],
  price: '8 349',
  priceWithoutVat: '6 900'
}];
var SUBSCRIPTION_PACKAGES_KEYS = ['taxes', 'wages', 'government'];
var SUBSCRIPTION_PACKAGES_KEYS_ENUM = {
  TAXES: 'taxes',
  WAGES: 'wages',
  GOVERNMENT: 'government'
};

/***/ }),

/***/ 4034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ lecturerApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var LIST = 'person/list/carousel';
var DETAIL = 'pv/person/slug';
var lecturerApi = {
  list: function list() {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LIST);
  },
  detail: function detail(slug) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug));
  },
  upcomingTrainings: function upcomingTrainings(slug, limit, offset, excludeEvents) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/upcoming/courses"), {
      limit: limit,
      offset: offset,
      excludeEvents: excludeEvents
    });
  },
  upcomingConferences: function upcomingConferences(slug, limit, offset) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/upcoming/conferences"), {
      limit: limit,
      offset: offset
    });
  },
  records: function records(slug, limit, offset, excludeEvents) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/archived/courses"), {
      limit: limit,
      offset: offset,
      excludeEvents: excludeEvents
    });
  }
};

/***/ }),

/***/ 58596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Lecturer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
;// CONCATENATED MODULE: ./src/ui/Lecturer/Lecturer.elements.tsx



var Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Lecturerelements__Wrapper",
  componentId: "sc-1urcrvf-0"
})(["display:inline-flex;align-items:center;margin-right:", ";margin-bottom:", ";cursor:pointer;"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10));
var ImageSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Lecturerelements__ImageSection",
  componentId: "sc-1urcrvf-1"
})(["position:relative;width:", ";height:", ";overflow:hidden;border-radius:50%;margin-right:", ";margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(32), (0,polished_esm/* rem */.hO)(32), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(2));
var Photo = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
  displayName: "Lecturerelements__Photo",
  componentId: "sc-1urcrvf-2"
})(["position:absolute;left:50%;top:50%;width:100%;height:auto;transform:translate(-50%,-50%);"]);
var Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Lecturerelements__Title",
  componentId: "sc-1urcrvf-3"
})(["font-weight:", ";color:", ";"], function (prop) {
  return prop.isBold ? prop.theme.fontWeights.textBold : prop.theme.fontWeights.textRegular;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grey;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Lecturer/Lecturer.tsx







var LecturerTemplate = function LecturerTemplate(_ref) {
  var image = _ref.image,
      isBold = _ref.isBold,
      name = _ref.name,
      slug = _ref.slug;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    onClick: function onClick() {
      return slug && router.push({
        pathname: "".concat(constants/* ROUTES.LECTURER */.Z6.LECTURER, "/").concat(slug)
      });
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageSection, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Photo, {
        src: image,
        width: 0,
        height: 0,
        alt: name,
        loader: function loader(_ref2) {
          var src = _ref2.src;
          return src;
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: name
    })]
  });
};

/* harmony default export */ var Lecturer = (LecturerTemplate);

/***/ }),

/***/ 42420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Package; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
;// CONCATENATED MODULE: ./src/ui/Package/Package.elements.tsx


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Packageelements__Wrapper",
  componentId: "sc-1xcvnya-0"
})(["display:inline-flex;width:", ";min-width:", ";height:", ";background:", ";align-items:center;justify-content:center;border-radius:", ";color:", ";font-weight:", ";font-size:", ";margin:0 ", " 0 ", ";"], (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(22), function (props) {
  return props.background;
}, (0,polished_esm/* rem */.hO)(24), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textRegular;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.textSmall;
}, (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(5));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Package/Package.tsx





var PackageTemplate = function PackageTemplate(_ref) {
  var symbol = _ref.symbol,
      color = _ref.color;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    background: color,
    children: symbol
  });
};

/* harmony default export */ var Package = (PackageTemplate);

/***/ }),

/***/ 67279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Tag; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
;// CONCATENATED MODULE: ./src/ui/Tag/Tag.elements.tsx


var Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Tagelements__Wrapper",
  componentId: "sc-1w7pdns-0"
})(["", ";", ";padding:", " ", ";margin-right:", ";margin-bottom:", ";border-radius:", ";text-transform:uppercase;font-size:", ";display:inline-block;"], function (prop) {
  return "color: ".concat(prop.color ? prop.color : prop.theme.colors.black);
}, function (prop) {
  return "border: 1px solid ".concat(prop.color ? prop.color : prop.theme.colors.black);
}, (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(4), function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.textSmall;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Tag/Tag.tsx




var TagTemplate = function TagTemplate(_ref) {
  var color = _ref.color,
      name = _ref.name;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    color: color,
    children: name
  });
};

/* harmony default export */ var Tag = (TagTemplate);

/***/ }),

/***/ 27098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ handleDownloadClick; },
/* harmony export */   "h": function() { return /* binding */ handleDownloadClickAsZip; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93162);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(file_saver__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55733);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(jszip__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40238);






var zip = new (jszip__WEBPACK_IMPORTED_MODULE_3___default())();
var handleDownloadClick = /*#__PURE__*/function () {
  var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(key, name, isCatalogDownload, type) {
    var _link, originalImage, _link2, image, imageBlog, imageURL, link;

    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!isCatalogDownload) {
              _context.next = 7;
              break;
            }

            _link = document.createElement('a');

            _link.setAttribute('target', '_blank');

            _link.href = (0,_constants__WEBPACK_IMPORTED_MODULE_4__/* .getCatalogUrl */ .pW)();
            _link.download = name;

            _link.dispatchEvent(new MouseEvent('click'));

            return _context.abrupt("return");

          case 7:
            originalImage = "".concat((0,_constants__WEBPACK_IMPORTED_MODULE_4__/* .getApiURL */ .tU)(), "/media/attachments/").concat(key);

            if (!(type === 'application/pdf')) {
              _context.next = 14;
              break;
            }

            _link2 = document.createElement('a');
            _link2.href = originalImage;
            _link2.download = 'file.pdf';

            _link2.dispatchEvent(new MouseEvent('click'));

            return _context.abrupt("return");

          case 14:
            _context.next = 16;
            return fetch(originalImage);

          case 16:
            image = _context.sent;
            _context.next = 19;
            return image.blob();

          case 19:
            imageBlog = _context.sent;
            imageURL = URL.createObjectURL(imageBlog);
            link = document.createElement('a');
            link.href = imageURL;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleDownloadClick(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
var handleDownloadClickAsZip = /*#__PURE__*/function () {
  var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(materials, eventSlug) {
    var formattedFiles, arrOfFiles;
    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            formattedFiles = materials.map(function (material) {
              return {
                url: "".concat((0,_constants__WEBPACK_IMPORTED_MODULE_4__/* .getApiURL */ .tU)(), "/media/attachments/").concat(material._key),
                name: "".concat(material.name).concat(getFileSuffixByMimeType(material.mime_type))
              };
            });
            arrOfFiles = formattedFiles.map(function (item) {
              return axios__WEBPACK_IMPORTED_MODULE_1___default().get(item.url, {
                responseType: 'blob'
              }).then(function (resp) {
                zip.file(item.name, resp.data);
              });
            });
            return _context2.abrupt("return", Promise.all(arrOfFiles).then(function () {
              zip.generateAsync({
                type: 'blob'
              }).then(function (blob) {
                (0,file_saver__WEBPACK_IMPORTED_MODULE_2__.saveAs)(blob, "".concat(eventSlug, ".zip"));
              });
            })["catch"](function (err) {
              console.log(err);
            }));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function handleDownloadClickAsZip(_x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

var getFileSuffixByMimeType = function getFileSuffixByMimeType(mimeType) {
  switch (mimeType) {
    case 'application/pdf':
      return '.pdf';

    case 'image/jpeg':
      return '.jpeg';

    case 'image/png ':
      return '.png';

    case 'text/plain':
      return '.txt';

    default:
      return '';
  }
};

/***/ }),

/***/ 19033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ formatLecturerName; }
/* harmony export */ });
var formatLecturerName = function formatLecturerName(person) {
  if (!person) return;
  return "".concat(person.titles.before_name ? "".concat(person.titles.before_name, " ") : '').concat(person.name, " ").concat(person.surname).concat(person.titles.after_name ? " ".concat(person.titles.after_name) : '');
};

/***/ })

}]);